import API from './axios';

export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  getProfile: () => API.get('/auth/profile'),
  changePassword: (data) => API.post('/auth/change-password', data),
  forgotPassword: (email) => API.post(`/auth/forgot-password?email=${encodeURIComponent(email)}`),
  resetPassword: (token, newPassword) => API.post(`/auth/reset-password?token=${encodeURIComponent(token)}&newPassword=${encodeURIComponent(newPassword)}`),
};

export const productAPI = {
  getAll: (page = 0, size = 12) => API.get(`/products?page=${page}&size=${size}`),
  getBySlug: (slug) => API.get(`/products/${slug}`),
  getByCategory: (categoryId, page = 0) => API.get(`/products/category/${categoryId}?page=${page}&size=12`),
  getFeatured: (page = 0) => API.get(`/products/featured?page=${page}&size=12`),
  search: (params) => API.get('/products/search', { params }),
  getBrands: () => API.get('/products/brands'),
};

export const categoryAPI = {
  getAll: () => API.get('/categories'),
  getTree: () => API.get('/categories/tree'),
  getBySlug: (slug) => API.get(`/categories/${slug}`),
};

export const cartAPI = {
  get: () => API.get('/cart'),
  addItem: (data) => API.post('/cart/items', data),
  updateQuantity: (itemId, quantity) => API.put(`/cart/items/${itemId}?quantity=${quantity}`),
  removeItem: (itemId) => API.delete(`/cart/items/${itemId}`),
  clear: () => API.delete('/cart'),
};

export const orderAPI = {
  create: (data) => API.post('/orders', data),
  getAll: (page = 0) => API.get(`/orders?page=${page}&size=10`),
  getById: (id) => API.get(`/orders/${id}`),
  cancel: (id, reason) => API.post(`/orders/${id}/cancel${reason ? `?reason=${encodeURIComponent(reason)}` : ''}`),
  track: (orderNumber) => API.get(`/orders/track/${orderNumber}`),
};

export const addressAPI = {
  getAll: () => API.get('/addresses'),
  create: (data) => API.post('/addresses', data),
  update: (id, data) => API.put(`/addresses/${id}`, data),
  remove: (id) => API.delete(`/addresses/${id}`),
};

export const reviewAPI = {
  getForProduct: (productId, page = 0) => API.get(`/reviews/product/${productId}?page=${page}&size=10`),
  create: (data) => API.post('/reviews', data),
  update: (id, data) => API.put(`/reviews/${id}`, data),
  remove: (id) => API.delete(`/reviews/${id}`),
};

export const wishlistAPI = {
  get: () => API.get('/wishlist'),
  add: (productId) => API.post(`/wishlist/${productId}`),
  remove: (productId) => API.delete(`/wishlist/${productId}`),
  check: (productId) => API.get(`/wishlist/check/${productId}`),
};

export const couponAPI = {
  validate: (code, orderTotal) => API.post(`/coupons/validate?code=${encodeURIComponent(code)}&orderTotal=${orderTotal}`),
};

export const supportAPI = {
  create: (data) => API.post('/support', data),
  getAll: (page = 0) => API.get(`/support?page=${page}&size=10`),
  getById: (id) => API.get(`/support/${id}`),
  addMessage: (id, data) => API.post(`/support/${id}/messages`, data),
};

export const paymentAPI = {
  createRazorpayOrder: (orderId) => API.post(`/payments/razorpay/create-order?orderId=${orderId}`),
  verifyPayment: (data) => API.post('/payments/razorpay/verify', data),
};

export const notificationAPI = {
  getAll: (page = 0) => API.get(`/notifications?page=${page}&size=20`),
  getUnreadCount: () => API.get('/notifications/unread-count'),
  markRead: (id) => API.put(`/notifications/${id}/read`),
  markAllRead: () => API.put('/notifications/read-all'),
};

export const siteAPI = {
  getSettings: () => API.get('/site/settings'),
};
